import React from 'react'
import { Button, Link } from '@vp/swan'
import { Cta } from '../../types/StandardHeroContent'
import { trackClickEvent } from '../../utils/tracking/tracking'

interface StandardHeroCTAProps {
  index: number
  cta: Cta
  merchandisingCategoryId: string
  pageZone: string
  ctaUrlsLength: number
}

const StandardHeroCTA: React.FC<StandardHeroCTAProps> = ({
  cta,
  index,
  merchandisingCategoryId,
  pageZone,
  ctaUrlsLength
}) => {
  const getSizeVariant = () => {
    return ctaUrlsLength === 1 ? undefined : 'mini'
  }

  return (
    cta &&
    cta.text &&
    cta.targetUrl && (
      <Link
        skin="unstyled"
        href={cta?.targetUrl}
        data-section={pageZone}
        data-translation={`CTA ${index + 1}`}
      >
        <Button
          key={`standard-hero-cta-${index}`}
          component="div"
          className="standard-hero-cta"
          skin={cta.skin}
          size={getSizeVariant()}
          onClick={() => {
            trackClickEvent({
              categoryId: merchandisingCategoryId,
              pageZone,
              ctaValue: `CTA ${index + 1}`,
              destinationUrl: cta!.targetUrl
            })
          }}
        >
          {cta?.text}
        </Button>
      </Link>
    )
  )
}

export default StandardHeroCTA
